import { CodeRunRequest } from "./codeTypes";
import { ParameterCreateParams, UpdatedParamsAndRefs } from "./parameterTypes";
import { FusaReply } from "./replyTypes";

export interface ValidationCreateParams {
  ruleType: ComparisonRuleType;
  subjectId: string;
  validationParameters: Omit<ParameterCreateParams, 'subjectId' | 'subjectType'>[];
  failMessage?: string;
  passMessage?: string;
  subjectType: ValidationSubjectType;
  script?: string;
  title?: string;
}

export interface ValidationBulkCreateParams extends Omit<ValidationCreateParams, 'validationParameters'> {
  id: string;
}

export enum ComparisonRuleType {
  GREATER_THAN = 'greaterThan',
  LESS_THAN = 'lessThan',
  EQUAL = 'equal',
  NOT_EQUAL = 'notEqual',
  GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual',
  LESS_THAN_OR_EQUAL = 'lessThanOrEqual',
  RANGE = 'range',
  PYTHON = 'python',
}

export enum ValidationSubjectType {
  Parameter = 'parameter',
  Container = 'container',
}

export interface ValidationParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  ruleType: ComparisonRuleType;
  subjectId: string;
  failMessage?: string;
  passMessage?: string;
  subjectType: ValidationSubjectType;
  script?: string;
  title?: string;
  /** The org that owns the validation. ValidationAccess writes it from the writer org; callers never choose it. */
  propelOrgId?: string;
}

export enum OPERAND_TYPE {
  OPERAND_A = 'operand_a',
  OPERAND_B = 'operand_b',
  RESULT = 'validation_result'
}


/**
 * A validation veriform-web has decided needs running, and everything the
 * runner on the user's machine needs to run it.
 *
 * It rides back on whatever write set it off -- a field edit, today -- because
 * the cascade that knows a validation is stale is on the server and the runner
 * is not. veriform-desktop runs it and answers to
 * `PUT /api/validations/:id/result`.
 */
export interface PendingValidation {
  validationId: string;
  runRequest: CodeRunRequest;
}

/** `PUT /api/validations/:id/result`. What the run made of the validation. */
export interface ValidationRunResultReply extends UpdatedParamsAndRefs, FusaReply {}
